import { Search } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export default function LookupForm({ parcelId, setParcelId, loading, onSubmit }) {
  return (
    <form
      onSubmit={onSubmit}
      data-testid="lookup-form"
      className="bg-white border border-border/60 rounded-2xl shadow-sm p-4 sm:p-6 flex flex-col sm:flex-row gap-3"
    >
      <div className="relative flex-1">
        <Search
          className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-[#8A9A86]"
          strokeWidth={1.5}
        />
        <Input
          data-testid="parcel-input"
          value={parcelId}
          onChange={(e) => setParcelId(e.target.value)}
          placeholder="e.g. 00059880006"
          className="pl-11 h-14 text-base font-mono tracking-wide bg-white border-border/60 focus:border-[#1A3626] focus:ring-1 focus:ring-[#1A3626] rounded-xl"
        />
      </div>
      <Button
        type="submit"
        data-testid="lookup-submit"
        disabled={loading}
        className="h-14 px-8 bg-[#1A3626] hover:bg-[#2D4A3A] text-white rounded-xl text-base transition-all hover:-translate-y-0.5 hover:shadow-sm"
      >
        {loading ? "Searching…" : "Look up"}
      </Button>
    </form>
  );
}
